import apiUtils from '@utils/apiUtils';
import dateUtils from '@utils/dateUtils';
import { apiConstants } from '../utils/constants';
import { fetchAPI } from './apiServiceHelper';

let api = {
    hotels: {
        hotelReservation: {
            get: ({ filter }) => {
                filter.childAges = filter.childCount
                    ? new Array(+filter.childCount).fill(10).join(',')
                    : '';

                return fetchAPI.getList(
                    `${apiConstants.BASE_URL}/api/hotels/details`,
                    apiUtils.normalizeQueryParams({
                        propertyIds: filter.ids,
                        provider: filter.provider.id,
                        apiKey: filter.apiKeys.id,
                        contract: filter.contract,
                        checkin: dateUtils.formatQueryParam(filter.checkin),
                        checkout: dateUtils.formatQueryParam(filter.checkout),
                        roomCount: filter.roomCount,
                        adultCount: filter.adultCount,
                        childCount: filter.childCount,
                        childAges: filter.childAges,
                        sort: 'POSITION_IDS',
                    })
                );
            },
        },
    },
};

export default api;
